import React from 'react'
import {
    Box,
    Stack,
} from '@mui/material'

import { projects } from './assets.js'
import data from '../../data/work.json'
import { FadBox } from '../../utils/fade-box/fadeBox.js'

const Work = () =>
    <Box textAlign={"center"}>
        <Stack
            data-aos="fade-up"
            direction={{ xs: "row" }}
            flexWrap={"wrap"}
            justifyContent="center"
            alignItems="center"
            px={10}
        >
            {data.map((project, index) =>
                <Box
                    title={project.name}
                    key={index}
                    width={{ xs: "100%", lg: "40%" }}
                    onClick={() => window.open(project.link, "_blank")}
                    m={5}>
                    <FadBox
                        src={projects[project.name]}
                        alt={project.alt}
                        text={"Open in Behance"} />
                </Box>
            )}
        </Stack >
    </Box >

export default Work